import React from 'react';
import { Phone } from 'lucide-react';
import { contactInfo } from '../../data/mock';

const FloatingCallButton = () => {
    return (
        <a
            href={contactInfo.phoneLink}
            className="floating-call-btn"
            aria-label="Call White Valley Cafe"
        >
            <Phone size={24} />
            <style>{`
        .floating-call-btn {
          position: fixed;
          bottom: 24px;
          right: 24px;
          width: 56px;
          height: 56px;
          background: linear-gradient(135deg, #D4A574 0%, #C49464 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          box-shadow: 0 4px 20px rgba(212, 165, 116, 0.4);
          text-decoration: none;
          z-index: 1000;
          transition: all 0.3s ease;
        }
        
        .floating-call-btn:hover {
          transform: scale(1.1);
          box-shadow: 0 6px 25px rgba(212, 165, 116, 0.5);
        }
        
        .floating-call-btn:active {
          transform: scale(0.95);
        }
        
        /* Mobile - make it slightly smaller */
        @media (max-width: 768px) {
          .floating-call-btn {
            bottom: 20px;
            right: 20px;
            width: 52px;
            height: 52px;
          }
        }
        
        /* Add pulse animation */
        .floating-call-btn::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: inherit;
          animation: pulse 2s infinite;
          z-index: -1;
        }
        
        @keyframes pulse {
          0% {
            transform: scale(1);
            opacity: 0.5;
          }
          50% {
            transform: scale(1.2);
            opacity: 0;
          }
          100% {
            transform: scale(1);
            opacity: 0;
          }
        }
      `}</style>
        </a>
    );
};

export default FloatingCallButton;
